<template>
  <mdb-card class="d-flex flex-row mt-4">
    <mdb-card-body>
      <mdb-btn
        size="lg"
        class="mt-n5 mb-n1 mdb-color px-4 py-4"
        :color="iconBackground"
        action
      >
        <mdb-icon
          :icon="cardIcon"
          size="2x"
        />
      </mdb-btn>
      <mdb-row>
        <mdb-col col="12">
          <mdb-card-title class="pt-4">{{ title }}
            <slot name="actions"/>
          </mdb-card-title>
        </mdb-col>
      </mdb-row>

      <slot name="content"/>

    </mdb-card-body>
  </mdb-card>
</template>

<script>
import {
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardBody,
  mdbCardTitle,
  mdbBtn,
  mdbIcon
} from 'mdbvue';
export default {
  name: 'MaterialCard',

  components: {
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardBody,
    mdbCardTitle,
    mdbBtn,
    mdbIcon
  },

  props: {
    title: {
      type: String,
      default: ''
    },
    cardIcon: {
      type: String,
      default: ''
    },
    iconBackground: {
      type: String,
      default: 'primary'
    }
  }
}
</script>
